import { Link, useLocation } from 'react-router-dom';
import axios from "axios";
import React, { useState, useEffect } from "react";
import CheckoutProgressModal from '../CheckoutProgressPopup';

function CustomerLogin() {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const location = useLocation();

  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [showEmailStage, setShowEmailStage] = useState(true);
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [shopName, setShopName] = useState('Kadhr');

  // ✅ Detect shop name from localStorage first
  useEffect(() => {
    const storedShop = localStorage.getItem('active_vendor_name_link');
    if (storedShop && storedShop.trim() !== '') {
      setShopName(storedShop);
    } else {
      setShopName('Kadhr');
    }
  }, []);

  // ✅ Send login code
  const sendVerificationCode = async () => {
    if (!email) {
      setErrorMsg('Please enter your email.');
      return;
    }

    setLoading(true);
    setErrorMsg('');
    setSuccessMsg('');

    try {
      const response = await axios.post(`${baseUrl}/customer/send-login-code/`, { 
        email, 
        shop_name: shopName 
      });

      if (response.data.bool) {
        setSuccessMsg(`Verification code sent! Check your inbox.`);
        setShowEmailStage(false);
      } else {
        setErrorMsg(response.data.message || 'Failed to send code.');
      }
    } catch {
      setErrorMsg('Network error. Try again.');
    } finally {
      setLoading(false);
    }
  };

  // ✅ Verify code
  const verifyCode = async () => {
    if (!code) {
      setErrorMsg('Please enter your code.');
      return;
    }

    setLoading(true);
    setErrorMsg('');
    setSuccessMsg('');

    try {
      const response = await axios.post(`${baseUrl}/customer/verify-login-code/`, { email, code });
      if (response.data.bool) {
        const { access_token, refresh_token, user, id } = response.data;

        const emailPrefix = email.split('@')[0];

        localStorage.setItem('access_token', access_token);
        localStorage.setItem('refresh_token', refresh_token);
        localStorage.setItem('customer_username', emailPrefix);
        localStorage.setItem('customer_email', email);
        localStorage.setItem('customer_id', id);
        localStorage.setItem('customer_login', true);

        setSuccessMsg('Login successful! Redirecting...');
        setTimeout(() => {
          window.location.href = '/customer/dashboard';
        }, 1000);
      } else {
        setErrorMsg(response.data.message || 'Invalid code.');
      }
    } catch {
      setErrorMsg('Verification failed. Try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="container mtopcon normal-mt-sctn">
      <div className="row">
        <div className="col-12 col-lg-4 reglogincon">
          <div className="card shadow-none">
            <div className="card-body">
              <h2 className="mb-3 text-center"><b>Welcome back</b></h2>

              {errorMsg && <p className="text-danger text-center">{errorMsg}</p>}
              {successMsg && <p className="text-success text-center">{successMsg}</p>}

              {showEmailStage ? (
                <>
                  <div className="mb-3">
                    <label className="form-label mb-0 font9">Email</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="form-control"
                      placeholder="abc@xyz.com"
                    />
                  </div>
                  <button
                    type="button"
                    onClick={sendVerificationCode}
                    disabled={loading}
                    className="col-12 btn btn-dark big-btn mt-2"
                  >
                    {loading ? 'Sending...' : 'Continue'}
                  </button>
                </>
              ) : (
                <>
                  <div className="mt-4 mb-4 border p-4 br-10">
                    <label className="form-label font9 dark-text mb-0"><b>Email Code</b></label>
                    <label className="form-label font8 grey-text mb-3">
                      Kindly enter the code sent to <u>{email}</u> to complete login.
                    </label>
                    <input
                      type="number"
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                      placeholder="- - - - - -"
                      className="form-control font9"
                    />
                    <div onClick={sendVerificationCode} className="font9 mt-3 text-blue pointer">
                      Resend
                    </div>
                    <button
                      type="button"
                      onClick={verifyCode}
                      disabled={loading}
                      className="col-12 btn btn-dark mt-3 big-btn"
                    >
                      {loading ? 'Verifying...' : 'Complete'}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <CheckoutProgressModal totalOrders={7} />
    </section>
  );
}

export default CustomerLogin;
